export default "__VITE_ASSET__BhS0UXXE__"